// extracted by mini-css-extract-plugin
module.exports = {"bannerImageOverlay":"style_bannerImageOverlay__1a4jD","bannerTitulo":"style_bannerTitulo__3h8Wb","sectionStyle":"style_sectionStyle__1oaVf"};